import { Component, OnDestroy, OnInit } from '@angular/core';
import { NewImportExportService } from '../../../_service/new-import-export.service';
import { Subscription } from 'rxjs';
import { User } from 'src/app/authentification/signin/credentials';
import { SigninService } from 'src/app/authentification/signin/signin.service';

@Component({
  selector: 'app-entretien-excel',
  templateUrl: './entretien-excel.component.html',
  styleUrls: ['./entretien-excel.component.css'],
})
export class EntretienExcelComponent implements OnInit, OnDestroy {
  excelData: any[][] | null = null;
  excelData$: Subscription;
  current: string = '';
  public currentUser: User = new User();
  selectedRowIndex: number | null = null;

  // Lignes de données (hors bandeau, hors entêtes, hors ligne "Total")
  dataRows: any[][] = [];
  // Dernière ligne du fichier ("Total"), affichée à part dans le tfoot
  totalRow: any[] | null = null;

  // A partir de cet index, les colonnes sont numériques
  // (Vidange, Frein, Réparation, Batterie, Pneu, Total) -> pour l'alignement + le format
  numericStartIndex = 5;

  constructor(
    private importExportService: NewImportExportService,
    private authService: SigninService
  ) {
    const storedUser = localStorage.getItem('currentUser');
    this.currentUser = storedUser ? JSON.parse(storedUser) : {};
  }

  ngOnInit(): void {
    this.excelData$ = this.importExportService
      .getExcelData()
      .subscribe((value) => {
        if (
          value != null &&
          Array.isArray(value) &&
          value.every((row) => Array.isArray(row))
        ) {
          this.excelData = value as any[][];
          this.extractRows();
          this.selectedRowIndex = null;
        }
      });
    this.fetchUser();
  }

  fetchUser(): void {
    this.current = this.authService.getCurrentUser().displayName;
  }

  ngOnDestroy(): void {
    if (this.excelData$) {
      this.excelData$.unsubscribe();
    }
    this.importExportService.setExcelData(null);
    this.importExportService.setCurentRapport(null);
    this.importExportService.setPdfToBePrinted(null);
    this.importExportService.setExcelToBeProcessed(null);
    this.selectedRowIndex = null;
  }

  selectRow(index: number): void {
    this.selectedRowIndex = index;
  }

  /**
   * Sépare le tableau brut renvoyé par le service en :
   * - dataRows : les lignes de données (à partir de la ligne 5 du fichier Excel)
   * - totalRow : la toute dernière ligne, si son 1ère cellule vaut "Total"
   */
  private extractRows(): void {
    if (!this.excelData || this.excelData.length <= 4) {
      this.dataRows = [];
      this.totalRow = null;
      return;
    }

    const rows = this.excelData.slice(4);
    const lastRow = rows[rows.length - 1];

    if (
      lastRow &&
      typeof lastRow[0] === 'string' &&
      lastRow[0].trim().toLowerCase() === 'total'
    ) {
      this.totalRow = lastRow;
      this.dataRows = rows.slice(0, -1);
    } else {
      this.totalRow = null;
      this.dataRows = rows;
    }
  }

  isNumeric(colIndex: number): boolean {
    return colIndex >= this.numericStartIndex;
  }
}